<script setup lang="ts">
const props = withDefaults(
    defineProps<{
        type?: 'Primary' | 'Secondary',
        state?: 'first' | 'second' | 'third' | 'fourth',
        vairant?: "primary" | "secondary" | 'yellow' | 'white' | 'blue',
    }>(),
    {
        type: 'Primary',
        state: 'first',
        vairant: 'primary'
    }
);
</script>

<template>
    <div
        :class="[
            $style['base-card'],
            $style[props.type],
            $style[props.state],
            $style[props.vairant],
        ]"
    >
        <div class="w-full relative z-1 text-center">
            <slot />
        </div>
    </div>
</template>

<style module>
.base-card {
    width: 100%;
    background: var(--card-bg);
    overflow: hidden;
    box-shadow: 0px 4px 89.7px 0px #005FEC14;
    position: relative;
}
.base-card.Primary {
    max-width: 450px;
    padding: 24px;
    border-radius: 20px;
}
.base-card.Secondary {
    max-width: 300px;
    padding: 56px 36px;
    border-radius: 12px;
}
.base-card::before {
    content: '';
    width: 100%;
    height: 100%;
    position: absolute;
    left: 0;
    top: 0;
}

/* Types.States */
.Primary.first::before {
    mask-image: url('/svg/new/curve-lines-01.svg');
    mask-repeat: no-repeat;
    mask-size: 100% auto;
    -webkit-mask-image: url('/svg/new/curve-lines-01.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% auto;
}
.Primary.second::before {
    mask-image: url('/svg/new/curve-lines-02.svg');
    mask-repeat: no-repeat;
    mask-size: 100% auto;
    -webkit-mask-image: url('/svg/new/curve-lines-02.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% auto;
}
.Primary.third::before {
    mask-image: url('/svg/new/curve-lines-03.svg');
    mask-repeat: no-repeat;
    mask-size: 100% auto;
    -webkit-mask-image: url('/svg/new/curve-lines-03.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% auto;
}
.Primary.fourth::before {
    mask-image: url('/svg/new/curve-lines-04.svg');
    mask-repeat: no-repeat;
    mask-size: 100% auto;
    -webkit-mask-image: url('/svg/new/curve-lines-04.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% auto;
}

.Secondary.first::before {
    mask-image: url('/svg/new/curve-lines-05.svg');
    mask-repeat: no-repeat;
    mask-position: center;
    mask-size: 100% auto;
    -webkit-mask-image: url('/svg/new/curve-lines-05.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% auto;
}
.Secondary.second::before {
    mask-image: url('/svg/new/curve-lines-06.svg');
    mask-repeat: no-repeat;
    mask-position: bottom;
    mask-size: 100% auto;
    -webkit-mask-image: url('/svg/new/curve-lines-06.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: bottom;
    -webkit-mask-size: 100% auto;
}
.Secondary.third::before {
    mask-image: url('/svg/new/curve-lines-03.svg');
    mask-repeat: no-repeat;
    mask-size: 100% auto;
    -webkit-mask-image: url('/svg/new/curve-lines-03.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% auto;
}
.Secondary.fourth::before {
    mask-image: url('/svg/new/curve-lines-04.svg');
    mask-repeat: no-repeat;
    mask-size: 100% auto;
    -webkit-mask-image: url('/svg/new/curve-lines-04.svg');
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-size: 100% auto;
}


/* Types.Variants */
.Primary.primary {
    --card-bg: linear-gradient(to bottom, var(--color-primary-600), var(--color-primary-800));
}
.Secondary.primary {
    --card-bg: linear-gradient(to bottom, var(--color-primary-500), var(--color-primary-700));
}
.Primary.primary::before,
.Secondary.primary::before {
    background-color: white;
    opacity: .2;
}
.Primary.primary h1, .Primary.primary h2,
.Primary.primary h3, .Primary.primary h4,
.Secondary.primary h1, .Secondary.primary h2,
.Secondary.primary h3, .Secondary.primary h4 {
    color: white;
}
.Primary.primary span, .Primary.primary p,
.Secondary.primary span, .Secondary.primary p {
    color: var(--color-primary-50);
}

.Primary.secondary {
    --card-bg: linear-gradient(to bottom, var(--color-secondary-500), var(--color-secondary-600));
}
.Secondary.secondary {
    --card-bg: var(--color-secondary-300);
}
.Primary.secondary::before,
.Secondary.secondary::before {
    background-color: white;
    opacity: .5;
}

.Primary.white {
    --card-bg: white;
    border: 1px solid var(--color-gray-300);
}
.Secondary.white {
    --card-bg: white;
}
.Primary.white::before,
.Secondary.white::before {
    background-color: #BDBDBD;
    opacity: .3;
}
.Primary.white span, .Primary.white p {
    color: var(--color-gray-500);
}
.Secondary.white span, .Secondary.white p {
    color: var(--color-primary-800);
}

.Primary.blue,
.Secondary.blue {
    --card-bg: linear-gradient(to bottom, var(--color-primary-100), var(--color-primary-400));
}
.Primary.blue::before,
.Secondary.blue::before {
    background-color: white;
    opacity: .4;
}
.Primary.blue span, .Primary.blue p {
    color: var(--color-gray-500);
}
.Secondary.blue span, .Secondary.blue p {
    color: var(--color-primary-800);
}
</style>